import { CountdownTimer } from "@biom3/react";

export const getTargetDate = (currentDateTime: Date) => {
  const endOfUTCDaySeconds = Date.UTC(
    currentDateTime.getUTCFullYear(),
    currentDateTime.getUTCMonth(),
    currentDateTime.getUTCDate(),
    23,
    59,
    59,
    0,
  );

  return new Date(endOfUTCDaySeconds + 1000);
};

interface CountDownProps {
  onUTCDayChange: () => void;
  hideSecondsOnMobile?: boolean;
}

export const Countdown = ({
  onUTCDayChange,
  hideSecondsOnMobile,
}: CountDownProps) => {
  const targetDate = getTargetDate(new Date());
  // temp hack to add 1 second since the `onCountdownEnd` returns 1 second earlier
  // adding 5 ensures we are on the new day, and gives time for the BE to update.
  targetDate.setSeconds(targetDate.getSeconds() + 5);

  return (
    <CountdownTimer
      testId="countdown-timer"
      size="large"
      variant="inverse"
      futureTarget={targetDate}
      hideDays={true}
      gap={"base.spacing.x2"}
      justifyContent={"left"}
      onCountdownEnd={onUTCDayChange}
      sx={{
        "& .CountdownTile[data-testid=CountdownTimer__Tile--seconds]": {
          d: hideSecondsOnMobile ? ["none", "flex"] : "flex",
        },
      }}
    />
  );
};
